import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { SeoHelmet, CONCERTS_SEO } from '../seo';

const CONCERT_IMG_1 = '/img/facebook/510592741_9799138800214871_7042336716925749074_n.jpg';
const CONCERT_IMG_2 = '/img/facebook/480769806_1573964203544987_3381674108270106440_n.jpg';
const CONCERT_IMG_3 = '/img/facebook/511067009_9799139030214848_5920321487021744733_n.jpg';
const CONCERT_IMG_4 = '/img/facebook/511179014_9799140426881375_1894487554786399150_n.jpg';
const CONCERT_IMG_5 = '/img/facebook/481446440_1576714833269924_9009749936560201507_n.jpg';
/** Ancienne image Hero — Montreux Jazz Festival */
const MONTREUX_HERO_IMG = '/img/patrick-noah-programme-concert.jpg';

const VENUES = [
  'Les Ulis, Parc Urbain – Paris, France',
  'Kazajoma, Bastos – Yaoundé, Cameroun',
  'Montreux Jazz Festival, Suisse',
  'Petit journal de Montparnasse',
  'La Cigale Paris, France',
  'Le Sunset Jazz Club Paris, France',
  'Fribourg Jazz Festival, Suisse',
  'Le Centre Culturel Français de Yaoundé, Cameroun',
  "L'Alliance Française de Yangon, Birmanie",
  'Le Sax\'Aphone Montpellier, France',
  'Festival Oh Les Beaux Jours Sallanches, France',
  "L'Entrepôt Grenoble, France",
  'ARCUEIL (94), Fête Quartier Kergomard',
  'La Teraza Hotel La Habana, Cuba',
  'Siège de l\'Unesco Paris, France',
  'La Bellevilloise Paris, France',
  "L'Entrepôt Paris, France",
  'Le Baiser Salé Jazz Club Paris, France',
  'Ville des Ulis, Espace culturel Boris Vian, France',
  "L'Abordage Evreux, France",
  'Africamania Festival Nice, France',
];

export function ConcertsPage() {
  return (
    <Container maxWidth="lg">
    <SeoHelmet {...CONCERTS_SEO} />
    <Box component="article" sx={{ py: 4 }}>
      <Typography variant="h2" color="primary" gutterBottom>
        Concerts
      </Typography>

      <Box sx={{ mb: 4 }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
            gap: 2,
          }}
        >
          {[
            { src: CONCERT_IMG_1, alt: 'Patrick Noah en concert' },
            { src: CONCERT_IMG_2, alt: 'Moment en concert' },
            { src: CONCERT_IMG_3, alt: 'Guitare en concert (noir et blanc)' },
          ].map(({ src, alt }) => (
            <Box
              key={src}
              sx={{
                borderRadius: 3,
                overflow: 'hidden',
                height: { xs: 200, md: 240 },
                boxShadow: '0 12px 40px rgba(26, 43, 72, 0.10)',
              }}
            >
              <Box component="img" src={src} alt={alt} sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
            </Box>
          ))}
        </Box>
      </Box>

      <Box component="ul" sx={{ m: 0, pl: 2.5, listStyle: 'none', '& li': { py: 0.75, borderBottom: '1px solid', borderColor: 'divider' } }}>
        {VENUES.map((venue) => (
          <li key={venue}>
            <Typography variant="body1" component="span">
              {venue}
            </Typography>
          </li>
        ))}
      </Box>

      <Box sx={{ mt: 5 }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
            gap: 2,
          }}
        >
          {[
            { src: MONTREUX_HERO_IMG, alt: 'Patrick Noah au Montreux Jazz Festival', objectPosition: 'center' },
            // Ajustement pour garder le visage entier sur la vignette du milieu.
            { src: CONCERT_IMG_4, alt: 'Patrick Noah en concert', objectPosition: 'center 20%' },
            { src: CONCERT_IMG_5, alt: 'Patrick Noah en concert', objectPosition: 'center' },
          ].map(({ src, alt, objectPosition }) => (
            <Box
              key={src}
              sx={{
                borderRadius: 3,
                overflow: 'hidden',
                height: { xs: 200, md: 240 },
                boxShadow: '0 12px 40px rgba(26, 43, 72, 0.12)',
              }}
            >
              <Box
                component="img"
                src={src}
                alt={alt}
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  objectPosition,
                  display: 'block',
                }}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
    </Container>
  );
}

export default ConcertsPage;
